export const getSingleLink = (state, key) => {
  return state?.links?.find(({ location }) => location === key)?.template
}
